import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import LanguageSelect from '../../components/common/LanguageSelect';
import RoleSelect from './RoleSelect';
import ISe360User from './ISe360User';
import { Col, ControlLabel, FormControl, FormGroup, HelpBlock, Row } from 'react-bootstrap';
import IRole from './IRole';
import FieldInfoIcon from '../../components/common/FieldInfoIcon';
import FormValidationService from '../../shared/form/FormValidationService';
import FormSelect from '../../components/common/FormSelect';
import ValidatableFormGroup from '../../components/common/ValidatableFormGroup';
import CountryCodePhoneNumberInput from '../../components/common/CountryCodePhoneNumberInput';

interface ISe360UserFormProps {
    input: ISe360User;
    onChange: (e: any) => void;
    availableRoles: IRole[];
    availableLanguages: any[];
    availableCountries: any[];
    isEditMode: boolean;
    errors: any;
}

const Se360UserForm = (props: ISe360UserFormProps) => {
    const { apiUrl } = window.appConfig;

    return (
        <form>
            <Row>
                <Col md={props.input.profileImageReference ? 8 : 12}>
                    <FormGroup>
                        <ControlLabel>
                            {Translate('se360users/modal/form/input-label/name')}
                        </ControlLabel>
                        <FormControl
                            autoFocus
                            type="text"
                            name="name"
                            value={props.input.name ? props.input.name : ''}
                            onChange={props.onChange}
                        />
                    </FormGroup>
                    <FormGroup
                        className="required"
                        validationState={FormValidationService.getValidationState(
                            props.errors.username
                        )}
                    >
                        <ControlLabel>
                            {Translate('se360users/modal/form/input-label/username')}
                        </ControlLabel>
                        <FormControl
                            type="text"
                            name="username"
                            value={props.input.username ? props.input.username : ''}
                            onChange={props.onChange}
                        />
                        {props.errors && <HelpBlock>{props.errors.username}</HelpBlock>}
                    </FormGroup>
                    <FormGroup
                        className="required"
                        validationState={FormValidationService.getValidationState(
                            props.errors.email
                        )}
                    >
                        <ControlLabel>
                            {Translate('se360users/modal/form/input-label/email-address')}
                        </ControlLabel>
                        <FormControl
                            type="email"
                            name="email"
                            value={props.input.email ? props.input.email : props.input.username}
                            onChange={props.onChange}
                        />
                        {props.errors && <HelpBlock>{props.errors.email}</HelpBlock>}
                    </FormGroup>
                    <FormGroup
                        validationState={FormValidationService.getValidationState(
                            props.errors.phoneNumber
                        )}
                    >
                        <ControlLabel>
                            {Translate('se360users/modal/form/input-label/enter-phone-number')}
                        </ControlLabel>
                        <FieldInfoIcon
                            title={Translate('popover/info/title/phonenumber')}
                            content={Translate('popover/info/content/phonenumber')}
                        />
                        <CountryCodePhoneNumberInput
                            value={props.input.phoneNumber}
                            onChange={(val) =>
                                props.onChange({
                                    target: { name: 'phoneNumber', value: val }
                                })
                            }
                        />
                        {props.errors && <HelpBlock>{props.errors.phoneNumber}</HelpBlock>}
                    </FormGroup>
                    <LanguageSelect
                        onChange={props.onChange}
                        languageKey={props.input.languageKey}
                        languages={props.availableLanguages}
                        errors={props.errors}
                    />
                    <ValidatableFormGroup required validationKey="role" errors={props.errors}>
                        <RoleSelect
                            onChange={props.onChange}
                            roles={props.availableRoles}
                            role={props.input.role}
                        />
                    </ValidatableFormGroup>
                    {props.availableCountries.length > 0 && (
                        <FormGroup>
                            <ControlLabel>
                                {Translate('se360users/modal/form/input-label/country')}
                            </ControlLabel>
                            <FormSelect
                                name="country"
                                value={props.input.country as any}
                                onChange={props.onChange}
                                defaultTranslateKey="role-select/select-label/default/select-country"
                            >
                                {props.availableCountries.map((c: any) => {
                                    return (
                                        <option key={c.id} value={c.id as any}>
                                            {Translate(c.name)}
                                        </option>
                                    );
                                })}
                            </FormSelect>
                        </FormGroup>
                    )}
                </Col>
                {props.input.profileImageReference && (
                    <Col className="profile-image-preview" md={3}>
                        <img src={`${apiUrl}/file/${props.input.profileImageReference}`} />
                    </Col>
                )}
            </Row>
        </form>
    );
};

export default Se360UserForm;
